// extracted by mini-css-extract-plugin
module.exports = {"modal":"SignInMessage_modal__3HAv9","modal_Text":"SignInMessage_modal_Text__31GRP"};